export default __webpack_public_path__ + "static/header_image-9a76078c7b027cfdfe06490faffe3204.svg";